import { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";

const ApplicationStatusContext = createContext({
  isApplicationOpen: false,
  checkingStatus: true,
});

export const ApplicationStatusProvider = ({ children }) => {
  const [isApplicationOpen, setIsApplicationOpen] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    const fetchApplicationStatus = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/settings/application-status`
        );
        setIsApplicationOpen(response.data.isOpen);
      } catch (error) {
        console.error("Error fetching application status:", error);
        // Default to closed if there's an error
        setIsApplicationOpen(false);
      } finally {
        setCheckingStatus(false);
      }
    };

    fetchApplicationStatus();
  }, []);

  return (
    <ApplicationStatusContext.Provider
      value={{ isApplicationOpen, checkingStatus }}
    >
      {children}
    </ApplicationStatusContext.Provider>
  );
};

export const useApplicationStatus = () => useContext(ApplicationStatusContext);
